import { useVisionA11y } from '../context/VisionAccessibilityContext';
import { useContent } from '../hooks/useContent';
import './VisionAccessibilityBar.css';

export default function VisionAccessibilityBar() {
  const { ui } = useContent();
  const a = ui.a11y;
  const { enabled, fontScale, increaseFont, decreaseFont, resetFont, disable } = useVisionA11y();

  if (!enabled) return null;

  return (
    <div className="a11y-bar" role="region" aria-label={a.panel}>
      <div className="a11y-bar__inner">
        <button type="button" className="a11y-bar__exit" onClick={disable}>
          {a.exit}
        </button>

        <div className="a11y-bar__group" role="group" aria-label={a.fontGroup}>
          <span className="a11y-bar__label">{a.font}</span>
          <button type="button" className="a11y-bar__btn" onClick={decreaseFont} aria-label={a.decreaseFont}>
            A−
          </button>
          <button type="button" className="a11y-bar__btn" onClick={resetFont} aria-label={a.resetFont}>
            A
          </button>
          <button type="button" className="a11y-bar__btn" onClick={increaseFont} aria-label={a.increaseFont}>
            A+
          </button>
          <span className="a11y-bar__hint">{Math.round(fontScale * 100)}%</span>
        </div>
      </div>
    </div>
  );
}
